import { render } from "./Sosial.vue?vue&type=template&id=e28b3c1a"
import script from "./Sosial.vue?vue&type=script&lang=js"
export * from "./Sosial.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__